import { Api } from "../../../../helpers/Api";
import { Col, Form, Row } from "react-bootstrap";
import _, { cloneDeep } from 'lodash';
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './FileUpload.css'

const FileUpload = (props) => {

    const column =
    {
        borderRadius: '100px',
        marginBottom: 10,
        position: 'relative',
    }
    const verticalCenter = {
        borderRadius: '100px',
        width: '28px',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        backgroundColor: 'white',
        right: -2,
        top: -5,
        cursor: 'pointer'
    }

    const onChange = (event) => {
        let formData = new FormData();
        _.forEach(event.target.files, file => {
            formData.append('files', file);
        })

        Api.uploadFile(formData).then(response => {
            let d = cloneDeep(props.images);
            _.forEach(response, data => {
                let dummy = { imageUrl: `${Api.base_url}${data.url}`, id: data.id }
                d.push(dummy);
            })
            props.setImages(d);
        });
    }
    const addMore = () => {
        let d = cloneDeep(props.News)
        d.push({ url: "" })
        props.pushNewss(d)
    }

    const Remove = (index) => {
        let d = cloneDeep(props.News)
        d.splice(index, 1);
        props.pushNewss(d)
    }

    const Deletefile = (index) => {
        let d = [];
        d = cloneDeep(props.images);
        if (d.length !== 0) {
        
            // Api.deleteFile(d[index].id);
            d.splice(index, 1);
            props.setImages(d);
        }
    }

    return (<>
        <h3 style={{ color: '#667085', marginTop: 20 }}>{props.Title}</h3>
        <Row>
            {props.News && props.News.map((d, index) => {
                return (
                    <Col md={4}>
                        <Form.Label><b>News</b></Form.Label>
                        <div id={index} style={column} >
                            <div onClick={() => Remove(index)} style={verticalCenter}>
                                <img src='../../../../images/closs-icon.svg' alt='closeicon' />
                            </div>
                            
                            <input type='text' id={index} value={props.News[index].url} className='form-control' name='Newss'
                                onChange={event => props.setNews(event.target.value, index)} placeholder="Enter url" />

                                {index === props?.News?.length - 1 && <div className='ad-news'>
                                    <button className='anchor mt-1' type='button' style={{ width: 'auto' }} onClick={() => addMore()}> 
                                    <img src='../../../../images/add-more.png' alt='AddIcon' />
                                    Add More</button>
                                </div>}
                        </div>
                    </Col>
                )
            })}
            <Col md={6}>
                <Form.Label ><b>Upload Images</b><span style={{color:'rgb(240, 68, 56)'}}> (Min 6 images)/(size300X300)*</span></Form.Label>
                <input type='file' className='form-control' name='file' multiple onChange={event => onChange(event)} />
            </Col>

            
        </Row>

        {props.images.length !== 0 &&
            <div>
                <Row>
                    <Form.Label style={{ color: '#667085' }}>Gallery</Form.Label>
                </Row>
            </div>}

        <Row>
            {props.images?.map((image, index) => (
                <Col md={4}>
                    <div id={index} style={column} >
                        <div onClick={() => Deletefile(index)} style={verticalCenter}>
                            <img src='../../../../images/closs-icon.svg' alt='closeicon' />
                        </div>
                        <img style={{ width: '100%', height: '350px', borderRadius:'5px' }} id={`img${index}`}
                            src={`${image.imageUrl.replace("itmatic.io","codebrigade.in")}`} alt="Uploaded_Image" />
                        <textarea placeholder='Add Image Caption...With date(eg:-28.02.1989)' value={image.caption} onChange={(e)=>{ 
                            let d = cloneDeep(props.images);
                            d[index].caption = e.target.value;
                            props.setImages(d)
                            }}  class="form-control mt-2" required></textarea>
                    </div>
                </Col>
            ))}
        </Row>
    </>
    )
};

export default FileUpload;
